// Use localStorage instead of cookies for better persistence and no size limits
// This is more suitable for JWT tokens which can be large

export function setCookie(key: string, value: string): boolean {
  try {
    localStorage.setItem(key, value);
    return true;
  } catch (error) {
    console.error("[storageProxy:setCookie] Failed to store:", error);
    if (error instanceof DOMException && error.name === 'QuotaExceededError') {
      console.error("[storageProxy] Storage quota exceeded");
    }
    return false;
  }
}

export function getCookie(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch (error) {
    return null;
  }
}

export function removeCookie(key: string) {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.error("[storageProxy:removeCookie] Failed to remove:", error);
  }
}
